/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import {
  MAGIC_VALUE,
  MINIMUM_SEARCH_CHARACTER
} from '../../shared/Utils/Constants';
import { SpecialCharacter } from '../../shared/Utils/Utils';
import { IAllConnectDetails } from '../IUtilityService';

export const setUsername = async (
  username: string,
  setAllConnectDetails: (allConnectDetails: IAllConnectDetails) => void,
  allConnectDetails: IAllConnectDetails
) => {
  if (username.length <= MAGIC_VALUE.HUNDRED)
    setAllConnectDetails({ ...allConnectDetails, username: username });
};

export const setPassword = (
  password: string,
  setAllConnectDetails: (allConnectDetails: IAllConnectDetails) => void,
  allConnectDetails: IAllConnectDetails
) => {
  if (password.length <= MAGIC_VALUE.HUNDRED)
    setAllConnectDetails({ ...allConnectDetails, password: password });
};

export const EMaaSNotificationCheck = (isDisabled: boolean) =>
  !isDisabled ? 'EMaaSNotificationHide' : 'EMaaSNotificationShow';

export const validate = (
  isSubmitted: boolean,
  validateMandatoryFields: () => void
) => {
  if (isSubmitted) validateMandatoryFields();
};

export const connectorConfigCheck = (
  SearchKeyword: string,
  isMinChar?: number
) => {
  if (isMinChar) {
    return 'search-utility-providers';
  }
  return SearchKeyword.length >= MINIMUM_SEARCH_CHARACTER
    ? 'search-utility-providers'
    : '';
};
